function readRuntimeConfig() {
  if (typeof window !== "undefined" && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__;
  }
  return {};
}

/** config.js 里 API_BASE: "" 表示同域 /api，须覆盖 build 时写入的 REACT_APP_API_BASE */
function getResolvedApiBase() {
  const runtime = readRuntimeConfig();
  if (Object.prototype.hasOwnProperty.call(runtime, "API_BASE")) {
    return String(runtime.API_BASE || "").replace(/\/$/, "");
  }
  return (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
}

export const API_BASE = getResolvedApiBase();

/** 统一 API 根地址（运行时 config.js 优先，供各页面使用） */
export function getApiBase() {
  return API_BASE;
}

export function apiUrl(path = "") {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE}${normalized}`;
}

export function assetUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const normalized = url.startsWith("/") ? url : `/${url}`;
  return `${API_BASE}${normalized}`;
}

export function apiFetch(path, options) {
  return fetch(apiUrl(path), options);
}

/** 请求 JSON 接口；若返回 HTML 则抛出明确错误（避免 <!doctype 解析报错） */
export async function apiJson(path, options) {
  const res = await apiFetch(path, options);
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  const text = await res.text();
  if (ct.includes("text/html") || text.trimStart().startsWith("<!")) {
    throw new Error(
      "API 返回了网页而非 JSON。请运行 deploy\\fix_hunlian_proxy.bat，或在宝塔添加整站反代到 127.0.0.1:8001"
    );
  }
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    const snippet = (text || "").replace(/\s+/g, " ").trim().slice(0, 120);
    if (res.ok) {
      throw new Error("服务器返回了非 JSON 数据");
    }
    if (res.status >= 500) {
      throw new Error(
        snippet
          ? `服务异常 (${res.status})：${snippet}`
          : `服务异常 (${res.status})，请稍后重试或查看后端日志`
      );
    }
    throw new Error(
      snippet
        ? `请求失败 (${res.status})：${snippet}`
        : `请求失败 (${res.status})，请确认后端 ${API_BASE || "反代 /api → :8001"} 已启动`
    );
  }
  return { res, data };
}
